module.exports = __webpack_public_path__ + "img/login2.f56320f3.png";